import last from 'lodash/last';
import keys from 'lodash/keys';
import get from 'lodash/get';
import { isNumber } from 'lodash';
import { financialValue } from '../../services/textService';
import { pxToRem } from '../highchart-utilities';

import {
  REPORTED_EBITDA_KEY,
  TOTALS_KEY,
  ADJUSTED_EBITDA_KEY,
} from '../../engine/utilities/constants';

export const getChartDisplayLabel = (name, value, decimalCount, labelColor) => {
  const financialDisplayValue = financialValue(value, {
    decimalCount,
    formatForScreenReader: false,
  });
  const numberLabelStyle = `font-family: Helvetica;`;
  const textLabelStyle = `font-family: Helvetica; font-size: ${pxToRem(
    12
  )}; color: ${labelColor};`;
  return `<span style="${numberLabelStyle}">${financialDisplayValue}</span><br /><span style="${textLabelStyle}">${name}</span>`;
};

const createDataPoint = (
  label,
  value,
  financialsDecimalCount,
  color,
  isSum,
  labelColor,
  xIndex
) => ({
  name: getChartDisplayLabel(label, value, financialsDecimalCount, labelColor),
  x: xIndex,
  y: value,
  isSum,
  accessibility: {
    description: label,
  },
  color,
});

export const createQofESeries = (
  qofeTimePeriods,
  qofeReportedEbitda,
  qofeAdjustedEbitda,
  qofeAdjustments,
  color,
  financialsDecimalCount,
  labelColor
) => {
  const timePeriod = last(qofeTimePeriods);
  let xIndex = 0;

  const reportedEbitdaValue = get(qofeReportedEbitda, timePeriod, 0);
  const reportedEbitdaDataPoint = createDataPoint(
    REPORTED_EBITDA_KEY,
    reportedEbitdaValue,
    financialsDecimalCount,
    color,
    false,
    labelColor,
    xIndex
  );

  const adjustmentDataPoints = keys(qofeAdjustments).map((adjustmentType) => {
    let dataPoint = get(
      qofeAdjustments,
      [adjustmentType, TOTALS_KEY, timePeriod],
      0
    );

    if (!isNumber(dataPoint)) {
      dataPoint = 0;
    }

    xIndex += 1;
    return createDataPoint(
      adjustmentType,
      dataPoint,
      financialsDecimalCount,
      null,
      false,
      labelColor,
      xIndex
    );
  });

  xIndex += 1;
  const adjustedEbitdaValue = get(qofeAdjustedEbitda, timePeriod, 0);
  const adjustedEbitdaDataPoint = createDataPoint(
    ADJUSTED_EBITDA_KEY,
    adjustedEbitdaValue,
    financialsDecimalCount,
    color,
    true,
    labelColor,
    xIndex
  );

  return [
    reportedEbitdaDataPoint,
    ...adjustmentDataPoints,
    adjustedEbitdaDataPoint,
  ];
};
